const exportToCsv = (rows, columnsToExtract, fileName) => {
  // Extract headers and fields from columnsToExtract
  const headers = columnsToExtract.map(column => column.headerName);
  const headerString = headers.join(',');

  // Extract row data using columnsToExtract
  const rowsString = rows.map(row => {
    return columnsToExtract.map(column => {
      const value = row[column.field] ?? '';
      // Handle values with commas
      return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
    }).join(',');
  }).join('\n');

  // Combine headers and rows
  const csvString = `${headerString}\n${rowsString}`;

  // Create and trigger download
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { exportToCsv };